import {
  adminPagesSlice,
  adminPageSlice,
  saveVersionSlice,
  previewPageSlice,
  createPageSlice,
} from './slices';

export const reducers = {
  adminPages: adminPagesSlice.reducer,
  adminPageDetails: adminPageSlice.reducer,
  previewPage: previewPageSlice.reducer,
  createPage: createPageSlice.reducer,
  savePage: saveVersionSlice.reducer,
};
